import { SxProps } from '@mui/material';

export const OptionCardStyles = {
  button: (optionColor: string) => ({
    border: `2px solid ${optionColor}`,
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: '12px',
    padding: '12px 20px',
    backgroundColor: '#f9f9f9',
    color: '#333',
    transition: 'all 0.3s ease',
    textTransform: 'none',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      borderColor: `${optionColor}`,
      backgroundColor: '#ffffff',
      transform: 'translateY(-3px)',
    },
    '&:active': {
      transform: 'translateY(1px)',
      boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
    },
  }),
  letterSpan: (optionColor: string) => ({
    marginRight: '12px',
    display: 'inline-block',
    fontSize: '1.2rem',
    backgroundColor: optionColor,
    color: '#fff',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    lineHeight: '36px',
    textAlign: 'center',
  }),
  descSpan: {
    fontSize: '0.95rem',
    flexGrow: 1,
    color: '#555',
    textAlign: 'left',
  },
} satisfies Record<string, ((optionColor: string) => SxProps) | SxProps>;
